module.exports = __webpack_public_path__ + "img/train-ing-icon.6c2d0ac9.png";